// frontend_react/src/components/paymodal/api.js

export {
  processReceiptPayment,
  fetchReceiptLines,
  fetchReceiptPayments,
  fetchReceiptFull,
  sendReceiptPdf,
  applyReceiptDiscount,
} from "../../services/receiptApi";

export const normalizeApiPayments = (raw) =>
  (raw || []).map((p, idx) => ({
    id: p.uuid || p.id || `pay_${idx}`,
    label: formatMethodLabel(p.means_payment || "?"),
    amount: Number(p.amount || 0),
    mode: "api",
  }));

function formatMethodLabel(key) {
  return {
    card: "TPE",
    cash: "Espèces",
    restaurant_ticket: "Resto",
    titre_resto: "Resto",
    card_contactless: "Sans Contact",
    amex: "AMEX",
    check: "Chèque",
  }[key] ?? key;
}

export const PAYMENT_METHOD_API_MAP = {
  tpe: "card",
  cash: "cash",
  resto: "restaurant_ticket",
  nfc: "card",
  amex: "card",
  cheque: "check",
};